import { render, staticRenderFns } from "./PayResultPackageContent.vue?vue&type=template&id=6fcbafcd&scoped=true&"
import script from "./PayResultPackageContent.vue?vue&type=script&lang=js&"
export * from "./PayResultPackageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcbafcd",
  null
  
)

export default component.exports